export default "__VITE_ASSET__yJgRINsm__"